<div class="w-100-p padding-10-lr padding-12-b scroll-y h-60">
  <div class="clr-row nxm clr-justify-content-center clr-align-items-end">
    @if (maskenListe(); as masken) {
      @if (masken.length) {
        <clr-select-container class="clr-col-auto clr-control-inline clr-align-items-end">
          <label for="maske">{{ 'Maske' | mrTranslate }}</label>
          <select clrSelect name="maske" [(ngModel)]="selectedMaske" [ngModelOptions]="{ standalone: true }">
            @for (maske of masken; track maske.ID) {
              <option [ngValue]="+maske.ID">{{ maske.Name }}</option>
            }
          </select>
        </clr-select-container>
        <clr-dropdown>
          <button type="button" class="btn-icon" clrDropdownTrigger aria-label="toggle settings menu">
            <cds-icon shape="cog" size="22" />
          </button>
          <clr-dropdown-menu *clrIfOpen clrPosition="bottom-left">
            <a (click)="addMaske('new')" clrDropdownItem>{{ 'Neue Maske erstellen' | mrTranslate }}</a>
            @if (selectedMaske()) {
              <div>
                <a (click)="addMaske('change')" clrDropdownItem>{{ 'Maskennamen ändern' | mrTranslate }}</a>
                <a (click)="addMaske('copy')" clrDropdownItem>{{ 'Maske speichern unter...' | mrTranslate }}</a>
                <a (click)="deleteMaske()" clrDropdownItem>{{ 'Maske löschen' | mrTranslate }}</a>
              </div>
            }
          </clr-dropdown-menu>
        </clr-dropdown>
      } @else {
        <button type="button" class="btn btn-primary" (click)="addMaske('new')">
          {{ 'Neue Maske erstellen' | mrTranslate }}
        </button>
      }
    }
    @if (!viewValid()) {
      <clr-alert clrAlertType="warning" [clrAlertClosable]="false" class="clr-col-md-8 clr-col">
        <clr-alert-item>
          <span class="alert-text">
            {{ 'Zuerst müssen Wartungarten eingetragen werden' | mrTranslate }}
          </span>
          <div class="alert-actions">
            <a (click)="view.emit('baum')" class="alert-action">{{ 'Gehen zu Wartungsbaum' | mrTranslate }}</a>
          </div>
        </clr-alert-item>
      </clr-alert>
    }
  </div>
  @if (selectedMaske()) {
    <div class="clr-row nxm h-60">
      <div class="clr-col-md-5 clr-col-10 h-100">
        <clr-datagrid
          #leftGrid
          class="datagrid-compact h-100 w-100-p wrapColumn"
          [clrDgItemsIdentityFn]="row => row?.ID"
          [clrDgSelectionType]="'multi'"
          [clrDgSelected]="selectedLeft()"
          (clrDgSelectedChange)="selectedLeft.set($event)"
          [clrDgRowSelection]="true">
          <clr-dg-column clrDgField="Bezeichnung">{{ 'Bezeichnung' | mrTranslate }}</clr-dg-column>
          <clr-dg-row *clrDgItems="let row of notUsedArten()" [clrDgItem]="row" [class.headerRow]="row.Typ == 0">
            <clr-dg-cell class="ellipsis">{{ row.Bezeichnung | tablePrettyPrint }}</clr-dg-cell>
          </clr-dg-row>
          <clr-dg-footer>{{ notUsedArten()?.length ?? 0 }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
        </clr-datagrid>
      </div>
      <div class="clr-col-md-1 clr-col-2 move-buttons">
        <button
          class="btn btn-link btn-state btn-state-custom-size add"
          [class.disabled]="!selectedLeft().length"
          (click)="moveToRight()"
          [clrLoading]="moveRightState()">
          <cds-icon shape="circle-arrow" direction="right" />
        </button>
        <button
          class="btn btn-link btn-state btn-state-custom-size delete"
          [class.disabled]="!selectedRight().length"
          (click)="moveToLeft()"
          [clrLoading]="moveLeftState()">
          <cds-icon shape="circle-arrow" direction="left" />
        </button>
      </div>
      <div class="clr-col-md-5 clr-col-10 h-100">
        <clr-datagrid
          #rightGrid
          class="datagrid-compact h-100 w-100-p wrapColumn"
          [clrDgItemsIdentityFn]="row => row?.ID"
          cdkDropList
          [cdkDropListData]="usedArten()"
          (cdkDropListDropped)="moveDrop($event)"
          [clrDgSelectionType]="'multi'"
          [clrDgSelected]="selectedRight()"
          (clrDgSelectedChange)="selectedRight.set($event)"
          [clrDgRowSelection]="true">
          <clr-dg-column class="fixed-cell" />
          <clr-dg-column>{{ 'Bezeichnung' | mrTranslate }}</clr-dg-column>

          <clr-dg-row
            *clrDgItems="let row of usedArten()"
            [clrDgItem]="row"
            [class.headerRow]="row.Typ == 0"
            cdkDrag
            [cdkDragData]="row">
            <clr-dg-cell class="fixed-cell" cdkDragHandle>
              <cds-icon shape="ellipsis-vertical" size="10" />
            </clr-dg-cell>
            <clr-dg-cell class="ellipsis">{{ row.Bezeichnung | tablePrettyPrint }}</clr-dg-cell>
          </clr-dg-row>
          <clr-dg-footer>{{ usedArten()?.length ?? 0 }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
        </clr-datagrid>
      </div>
      <div class="clr-col-md-1 clr-col-2 move-buttons">
        <button
          class="btn btn-link btn-state btn-state-custom-size"
          [class.disabled]="!enableMove().up"
          (click)="moveUpDown('up')"
          [clrLoading]="moveUpDownState()">
          <cds-icon shape="circle-arrow" direction="up" />
        </button>
        <button
          class="btn btn-link btn-state btn-state-custom-size"
          [class.disabled]="!enableMove().down"
          (click)="moveUpDown('down')"
          [clrLoading]="moveUpDownState()">
          <cds-icon shape="circle-arrow" direction="down" />
        </button>
      </div>
    </div>
  }
</div>

<clr-modal
  [clrModalOpen]="isOpenModalMaskenName()"
  (clrModalOpenChange)="isOpenModalMaskenName.set($event)"
  [clrModalClosable]="true">
  <h3 class="modal-title">
    {{
      (maskenAddStatus() == 'new' ? 'Eine neue Maske erstellen' : 'Die Maske unter anderem Namen speichern')
        | mrTranslate
    }}
  </h3>
  <div class="modal-body clr-row nxm">
    <form
      id="maske-name-form"
      (ngSubmit)="f.valid && saveMaske()"
      clrForm
      #f="ngForm"
      class="clr-col-12 width100"
      clrLayout="horizontal">
      <clr-input-container>
        <label for="Name">{{ 'Name' | mrTranslate }}</label>
        <input
          clrInput
          type="text"
          name="Name"
          [autofocus]="isOpenModalMaskenName()"
          (ngModelChange)="maskenNameNeu.set($event)"
          [ngModel]="maskenNameNeu()"
          required />
        <clr-control-error *clrIfError="'required'">
          {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
        </clr-control-error>
      </clr-input-container>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn" (click)="isOpenModalMaskenName.set(false)">
      {{ 'Abbrechen' | mrTranslate }}
    </button>
    <button type="submit" form="maske-name-form" class="btn btn-primary">
      {{ 'OK' | mrTranslate }}
    </button>
  </div>
</clr-modal>
